const mutations = {
  
    SET_PROCESSO_ID (state, value) {

        state.processo_id = value

    },

    SET_FATURAS_ALUNO (state, value) {

        state.faturas_aluno = value

    },
    SET_PAGAMENTO_ID (state, value) {

        state.pagamento_id = value

    },
    SET_FATURAS_INSERIDAS (state, value) {

        state.faturas_inseridas = value

    },
    ALL_PRODUTOS (state, value) {

        state.allProdutos = value

    },
}

export default mutations